export default {
  '/usercenter/security/disable-google-authenticator': {
    'exchange-nav-security': '/usercenter/security',
    'exchange-2fa-disableGoogleAuth': '',
  },
  '/usercenter/security/disable-sms-authenticator': {
    'exchange-nav-security': '/usercenter/security',
    'exchange-2fa-disableSMSAuth': '',
  },
  '/usercenter/security/enable-google-authenticator': {
    'exchange-nav-security': '/usercenter/security',
    'exchange-2fa-enableGoogleAuth': '',
  },
  '/usercenter/security/enable-sms-authenticator': {
    'exchange-nav-security': '/usercenter/security',
    'exhang-2fa-enableSMSAuth': '',
  },
  '/usercenter/wallet/withdrawals-email-verification': {
    'exchange-nav-wallet': '/usercenter/wallet/balances',
    'exchange-nav-withdraw': '/usercenter/wallet/withdrawals/BTC',
    'exchange-withdraw-confirmWithdrawRequest': '',
  },
  '/usercenter/wallet/withdraw-confirm-result': {
    'exchange-nav-wallet': '/usercenter/wallet/balances',
    'exchange-nav-withdraw': '/usercenter/wallet/withdrawals/BTC',
    'exhange-withdraw-confirmResult': '',
  },
  '/usercenter/settings/add-api-tip': {
    'exchange-nav-settings': '/usercenter/settings/profile',
    'exchange-nav-APIManagement': '/usercenter/settings/api-management',
    'exchange-APIMana-createNewAPI': '',
  },
  '/usercenter/settings/enable-withdraw-result': {
    'exchange-nav-settings': '/usercenter/settings/profile',
    'exchange-nav-APIManagement': '/usercenter/settings/api-management',
    'exchange-APIMana-enableWithdrawals': '',
  },
  '/usercenter/subAccount/create-sub-account-verification': {
    'Sub Account': '',
    'Account Management': '/usercenter/sub-account/account-management',
    'Create Sub Account': '',
  },
  '/usercenter/security/more-devices': {
    'exchange-nav-security': '/usercenter/security',
    'exchange-nav-deviceManagement': '/usercenter/security/device-management',
  },
  '/usercenter/security/disable-withdraw-whiteList': {
    'exchange-nav-security': '/usercenter/security',
    'exchange-nav-addressManagement': '/usercenter/security/address-management',
    'exchange-addressMana-turnOffWhitelist': '',
  },
  '/usercenter/security/disable-withdraw-whiteList-result': {
    'exchange-nav-security': '/usercenter/security',
    'exchange-nav-addressManagement': '/usercenter/security/address-management',
    'exchange-addressMana-turnOffWhitelist': '',
  },
  '/usercenter/security/add-to-whitelisted': {
    'exchange-nav-security': '/usercenter/security',
    'exchange-nav-addressManagement': '/usercenter/security/address-management',
    'exchange-addressMana-addToWhitelist': '',
  },
  '/usercenter/security/add-to-whitelisted-result': {
    'exchange-nav-security': '/usercenter/security',
    'exchange-nav-addressManagement': '/usercenter/security/address-management',
    'exchange-addressMana-addToWhitelist': '',
  },
  '/usercenter/security/disable-account': {
    'exchange-nav-security': '/usercenter/security',
    'exchange-nav-accountActivity': '/usercenter/security/account-activity',
    'exchange-nav-disableAccount': '',
  },
  '/usercenter/wallet/dust': {
    'exchange-nav-wallet': '/usercenter/wallet/balances',
    'exchange-nav-balances': '/usercenter/wallet/balances',
    'exchange-balance-convertToBNB': '',
  },
  '/usercenter/wallet/dust-history': {
    'exchange-nav-wallet': '/usercenter/wallet/balances',
    'exchange-nav-balances': '/usercenter/wallet/balances',
    'exchange-balance-convertToBNB': '/usercenter/wallet/dust',
    'exchange-balance-conversionHistory': '',
  },
  '/usercenter/settings/select-identity-verification-type': {
    'exchange-nav-settings': '/usercenter/settings/profile',
    'exchange-nav-profile': '/usercenter/settings/profile',
    'exchange-IDVerification-idendityVerificaiton': '',
  },
  '/usercenter/settings/identity-verification': {
    'exchange-nav-settings': '/usercenter/settings/profile',
    'exchange-nav-profile': '/usercenter/settings/profile',
    'exchange-IDVerification-idendityVerificaiton': '',
  },
  '/usercenter/settings/jumio-verifycation-result': {
    'exchange-nav-settings': '/usercenter/settings/profile',
    'exchange-nav-profile': '/usercenter/settings/profile',
    'exchange-IDVerification-idendityVerificaiton': '',
  },
  '/usercenter/settings/facial-verification': {
    'exchange-nav-settings': '/usercenter/settings/profile',
    'exchange-nav-profile': '/usercenter/settings/profile',
    'exchange-IDVerification-idendityVerificaiton': '',
  },
  '/usercenter/settings/facial-verification-result': {
    'exchange-nav-settings': '/usercenter/settings/profile',
    'exchange-nav-profile': '/usercenter/settings/profile',
    'exchange-IDVerification-idendityVerificaiton': '',
  },
  '/usercenter/security/device-management': {
    'exchange-nav-security': '/usercenter/security',
    'exchange-security-deviceManagement': '/usercenter/security/device-management',
  },
  '/usercenter/security/password-management': {
    'exchange-nav-security': '/usercenter/security',
    'exchange-security-loginPassword': '/usercenter/security/passoword-management',
  },
  '/usercenter/security/address-management': {
    'exchange-nav-security': '/usercenter/security',
    'exchange-security-addressManagement': '/usercenter/security/address-management',
  },
  '/usercenter/security/anti-phishing-code': {
    'exchange-nav-security': '/usercenter/security',
    'exchange-security-antiPhishingCode': '/usercenter/security/anti-phishing-code',
  },
  '/usercenter/security/account-activity': {
    'exchange-nav-security': '/usercenter/security',
    'exchange-security-accountActivity': '/usercenter/security/account-activity',
  },
};
